module.exports = __webpack_public_path__ + "static/media/Scenic_Rim.72aca9a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Scenic_Rim.jpg
// module id = 658
// module chunks = 0